
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import EnrolledCourseCard from "./EnrolledCourseCard";
import { Enrollment } from "@/types/enrollment";
import { useEffect, memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { devLog } from "@/utils/devLog";
import { performance } from "@/utils/performance";

interface EnrolledCoursesListProps {
  enrollments: Enrollment[];
  isLoading?: boolean;
}

// Use memo to prevent unnecessary re-renders
const EnrolledCoursesList = memo(function EnrolledCoursesList({ 
  enrollments = [], 
  isLoading 
}: EnrolledCoursesListProps) {
  // Track render performance - start and end in same effect
  useEffect(() => {
    devLog("[EnrolledCoursesList] Rendering with", {
      enrollmentCount: enrollments.length || 0,
      isLoading
    });
    
    const mark = performance.start('render-enrolled-courses-list');
    performance.end(mark);
  }, [enrollments, isLoading]);

  // Don't render anything if we're loading or have no data
  if (isLoading || enrollments.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Your Enrolled Courses</CardTitle>
        <CardDescription>Courses you're currently taking</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {enrollments.map((enrollment) => (
            <EnrolledCourseCard 
              key={enrollment.id} 
              enrollment={enrollment} 
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
});

export default EnrolledCoursesList;
